import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import {
  StyledUserInfoTitleContainer,
  AvatarRow,
  StyledIconField,
  StyledFieldLabel,
  StyledFieldValue,
  CopyIconButton,
} from "./UserInfo.style";
import { useTheme } from "@mui/styles";
import { useIntl } from "react-intl";
import { getUserAvatarIcon } from "features/metadesk/utils";
import { getShortAddress } from "features/helpers/utils";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import UserTag from "features/metadesk/components/UserTag";
import { StyledSkeleton } from "components/LoadingComponent/LoadingComponent.styles";
import _ from "lodash";

const UserInfoTitle = ({ entityName, userBasicInfo, isLoading }) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const copyFn = useCopyToClipboard();

  const [tags, setTags] = useState([]);
  useEffect(() => {
    setTags(_.get(userBasicInfo, "tags", []));
  }, [userBasicInfo]);

  const uid = _.get(userBasicInfo, "uid");
  const didName = _.get(userBasicInfo, "didNames[0].name");
  const avatar = getUserAvatarIcon(uid, theme, didName);

  return (
    <StyledUserInfoTitleContainer>
      <AvatarRow>
        {isLoading ? (
          <StyledSkeleton
            variant="circular"
            animation="wave"
            sx={{
              marginRight: "8px",
              minWidth: 48,
              minHeight: 48,
              borderRadius: "50%",
            }}
          />
        ) : (
          <img
            src={require(`assets/img/${avatar}`)}
            className="avatar"
            style={{ width: 48, height: 48 }}
          />
        )}
        <Box>
          <StyledIconField sx={{ marginBottom: "0" }}>
            {" "}
            {isLoading ? (
              <StyledSkeleton animation="wave" width={120} />
            ) : (
              <>
                <StyledFieldLabel>UID</StyledFieldLabel>
                <StyledFieldValue>{getShortAddress(uid)}</StyledFieldValue>{" "}
              </>
            )}
            {!isLoading && (
              <CopyIconButton size={18} onClick={() => copyFn(uid)}>
                <i className="meta-crm-icon-ic_copy font-size-16" />
              </CopyIconButton>
            )}
          </StyledIconField>
          {/* Tags */}
          <UserTag
            width={"auto"}
            showNumber={10}
            entityName={entityName}
            userInfo={{
              uid,
              tags: [
                ...tags.map((tag) => ({
                  _id: tag.tagId,
                  ...tag,
                })),
              ],
            }}
            setUser={({ tags: updatedTags }) => {
              setTags(
                updatedTags.map((tag) => ({
                  _id: tag.tagId,
                  ...tag,
                }))
              );
            }}
          />
        </Box>
      </AvatarRow>
    </StyledUserInfoTitleContainer>
  );
};

export default UserInfoTitle;
